<section class="share-shell">
  <div class="share-page">
    <header class="share-topbar">
      <div class="share-brand">
        <div class="share-brand__mark">ControlDocs</div>
        <div class="share-brand__copy">
          <strong>Biblioteca compartilhada</strong>
          <span>Acesso restrito apenas ao conteúdo liberado neste link</span>
        </div>
      </div>
      <button *ngIf="state === 'content'" class="ghost-btn" type="button" (click)="reset()">Encerrar acesso</button>
    </header>

    <section class="share-card access-card" *ngIf="state !== 'content'">
      <ng-container *ngIf="state !== 'error'; else errorState">
        <div class="section-badge">Controldocs · Compartilhamento</div>
        <h1>Acessar conteúdo compartilhado</h1>
        <p>Informe a senha para visualizar as pastas e arquivos disponíveis neste link.</p>

        <form class="access-form" (ngSubmit)="submit()">
          <label for="share-password">Senha de acesso</label>
          <input
            id="share-password"
            type="password"
            [(ngModel)]="password"
            name="password"
            placeholder="Informe a senha recebida" />
          <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
          <button class="primary-btn" type="submit" [disabled]="state === 'loading'">
            {{ state === 'loading' ? 'Verificando...' : 'Acessar conteúdo' }}
          </button>
        </form>
      </ng-container>

      <ng-template #errorState>
        <div class="section-badge">Controldocs · Compartilhamento</div>
        <h1>Não foi possível abrir este link</h1>
        <p class="error">{{ errorMessage || 'Este acesso foi removido ou expirou.' }}</p>
        <button class="primary-btn" type="button" (click)="reset()">Tentar novamente</button>
      </ng-template>
    </section>

    <ng-container *ngIf="state === 'content' && data">
      <ng-container *ngIf="data.type === 'FILE' && data.file">
        <section class="share-card single-file-card">
          <div class="section-badge">Arquivo compartilhado</div>
          <div class="single-file-card__body">
            <div class="single-file-card__meta">
              <h1>{{ data.file.name }}</h1>
              <p>{{ data.file.file_type || 'Arquivo' }} · {{ formatFileSize(data.file.file_size) }}</p>
            </div>
            <button class="primary-btn" type="button" (click)="openSharedFile(data.file)">Abrir arquivo</button>
          </div>
        </section>
      </ng-container>

      <ng-container *ngIf="data.type === 'FOLDER'">
        <section class="share-card workspace-card">
          <div class="workspace-card__header">
            <div>
              <div class="section-badge">Pasta compartilhada</div>
              <h1>{{ data.folder?.name }}</h1>
            </div>
            <div class="workspace-card__stats">
              <span>{{ filteredSubfolders.length }} subpastas</span>
              <span>{{ filteredFiles.length }} arquivos</span>
            </div>
          </div>

          <div class="workspace-toolbar">
            <nav class="share-breadcrumb">
              <ng-container *ngFor="let crumb of breadcrumbs; let i = index">
                <button type="button" (click)="navigateBreadcrumb(i)" [disabled]="i === breadcrumbs.length - 1">
                  {{ crumb.name }}
                </button>
                <span *ngIf="i < breadcrumbs.length - 1">/</span>
              </ng-container>
            </nav>

            <label class="search-field">
              <mat-icon>search</mat-icon>
              <input type="text" [(ngModel)]="searchTerm" name="share_search" placeholder="Buscar pastas e arquivos..." />
            </label>
          </div>

          <section class="content-panel folders-panel">
            <div class="content-panel__head">
              <h2>Pastas</h2>
              <span>{{ filteredSubfolders.length }} itens</span>
            </div>

            <div class="folder-grid" *ngIf="hasSubfolders(); else emptyFolders">
              <button
                class="folder-card"
                *ngFor="let folder of filteredSubfolders"
                type="button"
                [class.active]="folder.id === currentFolderId"
                (click)="openSharedFolder(folder, $event)">
                <span class="folder-card__icon">
                  <mat-icon>folder</mat-icon>
                </span>
                <span class="folder-card__body">
                  <strong>{{ folder.name }}</strong>
                  <small>{{ folderTypeLabel(folder) }}</small>
                </span>
                <mat-icon class="folder-card__arrow">chevron_right</mat-icon>
              </button>
            </div>

            <ng-template #emptyFolders>
              <div class="empty-state">
                <mat-icon>folder_off</mat-icon>
                <span>Nenhuma subpasta disponível.</span>
              </div>
            </ng-template>
          </section>

          <section class="content-panel files-panel">
            <div class="content-panel__head">
              <h2>Arquivos</h2>
              <span>{{ filteredFiles.length }} itens</span>
            </div>

            <div class="documents-table-wrap" *ngIf="hasFiles(); else emptyFiles">
              <table class="folders-table share-files-table">
                <colgroup>
                  <col class="col-doc" />
                  <col class="col-type" />
                  <col class="col-updated" />
                  <col class="col-actions" />
                </colgroup>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Tipo</th>
                    <th>Tamanho</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let file of filteredFiles" (click)="openSharedFile(file, $event)">
                    <td class="folder-name-cell">
                      <span class="list-cell-with-icon">
                        <mat-icon>description</mat-icon>
                        <span class="list-cell-main">
                          <span class="list-cell-title">{{ file.name }}</span>
                        </span>
                      </span>
                    </td>
                    <td>{{ file.file_type || 'Arquivo' }}</td>
                    <td>{{ formatFileSize(file.file_size) }}</td>
                    <td class="action-cell">
                      <button class="share-link-btn" type="button" (click)="openSharedFile(file, $event)">
                        <mat-icon>open_in_new</mat-icon>
                        <span>Abrir</span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <ng-template #emptyFiles>
              <div class="empty-state">
                <mat-icon>insert_drive_file</mat-icon>
                <span>Nenhum arquivo disponível nesta pasta.</span>
              </div>
            </ng-template>
          </section>

          <div class="loading-state" *ngIf="folderLoading">
            <mat-icon>sync</mat-icon>
            <span>Carregando conteúdo...</span>
          </div>
        </section>
      </ng-container>
    </ng-container>
  </div>
</section>
